import { EPermissoes } from '@/enums/ePermissoes';

export default [
  {
    description: 'Cadastro Graute',
    path: 'graute',
    name: 'graute',
    component: () => import('@/views/concreto/concreto/Index.vue'),
    goesToMenu: true,
    meta: {
      utlTipoFornecimentoId: 4,
      permissions: [EPermissoes.CadastroProduto],
      escopoObra: 'global'
    }
  },
  {
    description: 'Inclusão de Graute',
    path: 'graute/incluir',
    name: 'grauteinsert',
    component: () => import('@/views/concreto/concreto/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'graute',
      utlTipoFornecimentoId: 4,
      permissions: [EPermissoes.CadastroProduto],
      grupos: []
    }
  },
  {
    description: 'Inclusão de Graute',
    path: 'graute/incluir/:id',
    name: 'grauteinsertcopy',
    component: () => import('@/views/concreto/concreto/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'graute',
      utlTipoFornecimentoId: 4,
      permissions: [EPermissoes.CadastroProduto],
      grupos: []
    }
  },
  {
    description: 'Edição de Graute',
    path: 'graute/editar/:id',
    name: 'grauteupdate',
    component: () => import('@/views/concreto/concreto/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'graute',
      utlTipoFornecimentoId: 4,
      permissions: [EPermissoes.CadastroProduto],
      grupos: []
    }
  },
  {
    description: 'Fornecedor de Graute',
    path: 'fornecedor-obra',
    name: 'fornecedorobra-graute',
    component: () => import('@/views/gestao/fornecedor-obra/Index.vue'),
    meta: {
      utlTipoFornecimentoId: 4,
      permissions: [EPermissoes.CadastroObra],
      escopoObra: 'obra'
    },
    goesToMenu: true
  },
  {
    description: 'Unidade de Graute',
    path: 'unidade',
    name: 'unidadegraute',
    component: () => import('@/views/gestao/unidade/Index.vue'),
    meta: {
      tipoFornecimento: 'graute',
      utlTipoFornecimentoId: 4,
      permissions: [EPermissoes.CadastroObra],
      escopoObra: 'obra'
    },
    goesToMenu: true
  },
  {
    description: 'Inclusão de Unidade de Graute',
    path: 'unidade/incluir',
    name: 'inclusaounidadegraute',
    component: () => import('@/views/gestao/unidade/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'unidadegraute',
      utlTipoFornecimentoId: 4,
      permissions: [EPermissoes.CadastroObra]
    },
    goesToMenu: false
  },
  {
    description: 'Edição de Unidade Graute',
    path: 'unidade/editar/:id',
    name: 'unidadegrauteupdate',
    meta: {
      parentRouteName: 'unidadegraute',
      utlTipoFornecimentoId: 4,
      permissions: [EPermissoes.CadastroObra]
    },
    component: () => import('@/views/gestao/unidade/InclusaoEdicao.vue')
  },
  {
    description: 'Unidade Tipo Graute',
    path: 'unidade-tipo',
    name: 'unidadetipograute',
    component: () => import('@/views/gestao/unidade-tipo/Index.vue'),
    goesToMenu: true,
    meta: {
      tipoFornecimento: 'graute',
      utlTipoFornecimentoId: 4,
      permissions: [EPermissoes.CadastroObra],
      grupos: [],
      ambienteRouteName: 'ambientegraute',
      escopoObra: 'obra'
    }
  },
  {
    description: 'Inclusão Unidade Tipo Graute',
    path: 'unidade-tipo/incluir',
    name: 'unidadetipograuteinsert',
    component: () => import('@/views/gestao/unidade-tipo/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'unidadetipograute',
      utlTipoFornecimentoId: 4,
      permissions: [EPermissoes.CadastroObra]
    }
  },
  {
    description: 'Edição de Unidade Tipo Graute',
    path: 'unidade-tipo/editar/:id',
    name: 'unidadetipograuteupdate',
    meta: {
      parentRouteName: 'unidadetipograute',
      utlTipoFornecimentoId: 4,
      permissions: [EPermissoes.CadastroObra]
    },
    component: () => import('@/views/gestao/unidade-tipo/InclusaoEdicao.vue')
  },
  {
    description: 'Local de Aplicação',
    path: 'ambiente/:gesUnidadeTipoId',
    name: 'ambientegraute',
    component: () => import('@/views/gestao/ambiente/Index.vue'),
    goesToMenu: false,
    meta: {
      tipoFornecimento: 'graute',
      utlTipoFornecimentoId: 4,
      permissions: [EPermissoes.CadastrosBase],
      grupos: [],
      escopoObra: 'obra'
    }
  },
  {
    description: 'Inclusão de Local de Aplicação',
    path: 'ambiente/incluir/:gesUnidadeTipoId',
    name: 'ambientegrauteinsert',
    component: () => import('@/views/gestao/ambiente/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'ambientegraute',
      tipoFornecimento: 'graute',
      utlTipoFornecimentoId: 4,
      permissions: [EPermissoes.CadastrosBase],
      grupos: []
    }
  },
  {
    description: 'Edição de Local de Aplicação',
    path: 'ambiente/editar/:gesUnidadeTipoId/:id',
    name: 'ambientegrauteupdate',
    component: () => import('@/views/gestao/ambiente/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'ambientegraute',
      tipoFornecimento: 'graute',
      utlTipoFornecimentoId: 4,
      permissions: [EPermissoes.CadastrosBase],
      grupos: []
    }
  },
  {
    description: 'Tipo de Ensaio',
    path: 'tipo-ensaio',
    name: 'tipoensaiograute',
    component: () => import('@/views/utilidade/tipoensaio/Index.vue'),
    goesToMenu: true,
    meta: {
      utlTipoFornecimentoId: 4,
      alternarTipoEnsaio: true,
      tipoEnsaioRouteNameFresco: 'grautetipoensaiofresco',
      tipoEnsaioRouteNameEndurecido: 'grautetipoensaioendurecido',
      permissions: [EPermissoes.CadastroObra],
      escopoObra: 'global'
    }
  },
  {
    description: 'Tipo de Ensaio Fresco',
    path: 'tipo-ensaio-fresco',
    name: 'grautetipoensaiofresco',
    redirect: { name: 'tipoensaiograute' },
    goesToMenu: false,
    meta: {
      utlTipoFornecimentoId: 4,
      ensaioFresco: true,
      permissions: [EPermissoes.CadastroObra]
    }
  },
  {
    description: 'Inclusão de Tipo de Ensaio Fresco',
    path: 'tipo-ensaio-fresco/incluir',
    name: 'grautetipoensaiofrescoinsert',
    component: () => import('@/views/utilidade/tipoensaio/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'grautetipoensaiofresco',
      utlTipoFornecimentoId: 4,
      ensaioFresco: true,
      permissions: [EPermissoes.CadastroObra]
    }
  },
  {
    description: 'Edição de Tipo de Ensaio Fresco',
    path: 'tipo-ensaio-fresco/editar/:id',
    name: 'grautetipoensaiofrescoupdate',
    component: () => import('@/views/utilidade/tipoensaio/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'grautetipoensaiofresco',
      utlTipoFornecimentoId: 4,
      ensaioFresco: true,
      permissions: [EPermissoes.CadastroObra]
    }
  },
  {
    description: 'Tipo de Ensaio Endurecido',
    path: 'tipo-ensaio-endurecido',
    name: 'grautetipoensaioendurecido',
    redirect: { name: 'tipoensaiograute' },
    goesToMenu: false,
    meta: {
      utlTipoFornecimentoId: 4,
      ensaioFresco: false,
      permissions: [EPermissoes.CadastroObra]
    }
  },
  {
    description: 'Inclusão de Tipo de Ensaio Endurecido',
    path: 'tipo-ensaio-endurecido/incluir',
    name: 'grautetipoensaioendurecidoinsert',
    component: () => import('@/views/utilidade/tipoensaio/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'grautetipoensaioendurecido',
      utlTipoFornecimentoId: 4,
      ensaioFresco: false,
      permissions: [EPermissoes.CadastroObra]
    }
  },
  {
    description: 'Edição de Tipo de Ensaio Endurecido',
    path: 'tipo-ensaio-endurecido/editar/:id',
    name: 'grautetipoensaioendurecidoupdate',
    component: () => import('@/views/utilidade/tipoensaio/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'grautetipoensaioendurecido',
      utlTipoFornecimentoId: 4,
      ensaioFresco: false,
      permissions: [EPermissoes.CadastroObra]
    }
  }
];
